import styled from "styled-components";
import { breakpoints } from "../../globalStyles";

export const ReleasesList = styled.ul`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ReleaseSkeleton = styled.span`
  height: 88px;

  @media ${breakpoints.sm} {
    height: 48px;
  }
`;
